import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import classNames from './TabPanel.scss';

export default class TabPanel extends Component {
  static propTypes = {
    className: PropTypes.string,
    getLink  : PropTypes.func,
    onClick  : PropTypes.func,
    items    : PropTypes.array,
  };

  static defaultProps = {
    items: [],
  };

  state = {
    active: -1
  };

  setActive = (id) => {
    this.setState({
      active: this.props.items.map(item => item.id).indexOf(id)
    });
  }

  unsetActive = (id) => {
    this.setActive(-1);
  }

  render () {
    const items = this.props.items.map((item, num) => {
      return (
        <TabPanelItem
          key          = {num}
          num          = {num}
          item         = {item}
          isActive     = {this.state.active === num}
          getLink      = {this.props.getLink}
          onClick      = {this.props.onClick}
          onMouseEnter = {this.setActive}
          onMouseLeave = {this.unsetActive}
        />
      );
    });

    return (
      <div className={classNames.tabPanel + ' ' + this.props.className}>
        {items}
      </div>
    );
  }
}

@withTranslation(['main'], { i18n, wait: !!window })
export class TabPanelItem extends Component {
  static propTypes = {
    item        : PropTypes.object,
    isActive    : PropTypes.bool,
    getLink     : PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onClick     : PropTypes.func,
    t           : PropTypes.func,
  };

  state = {
    isActive: this.props.isActive || false
  };

  UNSAFE_componentWillReceiveProps (props) {
    if (props.hasOwnProperty('isActive')) {
      this.setState({
        isActive: props.isActive
      });
    }
  }

  render () {
    const { item, getLink, onMouseEnter, onMouseLeave, onClick } = this.props;
    const linkTo = getLink(item);
    const TopTag = linkTo ? Link : 'div';
    const topTagParams = linkTo ? { to: linkTo } : {};

    const offers_plural = this.props.t('offers', {count: parseInt(item.top, 10)});

    return (
      <TopTag
        className={this.state.isActive ? classNames.tabPanelItemActive : classNames.tabPanelItem}
        onMouseEnter={() => onMouseEnter(item.id)}
        onTouchStart={() => onMouseEnter(item.id)}
        onMouseLeave={() => onMouseLeave(item.id)}
        onTouchEnd={() => onMouseLeave(item.id)}
        onClick={onClick && (() => onClick(item.id))}
        { ...topTagParams }
      >
        <div className={classNames.itemWrapper}>
          <div className={classNames.itemTop}>{item.top} {offers_plural}</div>
          <div className={classNames.itemTitle}>{item.title}</div>
          <div className={classNames.itemDescription}>
            <div className={classNames.itemDescriptionHeader}>
              {item.description}
            </div>
            <div className={classNames.itemDescriptionBody}>
              {offers_plural}
            </div>
          </div>
        </div>
      </TopTag>
    );
  }
}
